import * as firebase from 'firebase/app';

import 'firebase/analytics';
import 'firebase/firestore';
import 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyA2IAJN_MfQWi9c6hQZs4KYnfO41Ok5e2Q',
  authDomain: 'rewards-user-authentication.firebaseapp.com',
  databaseURL: 'https://rewards-user-authentication.firebaseio.com',
  projectId: 'rewards-user-authentication',
  storageBucket: 'rewards-user-authentication.appspot.com',
  messagingSenderId: '431395576260',
  appId: '1:431395576260:web:90c96341a0c55b34beec91',
  measurementId: 'G-G4LXC14QSH',
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
